import BaseRepository from './base.repository';

class MyMedicationRepository extends BaseRepository {
  constructor() {
    super('/haven');
  }

  findAll(conditions) {
    return this.client.get('/medication-dispensed/medications', conditions);
  }

  findDetail(medUnique) {
    return this.client.get(`/medication-dispensed/medications/${medUnique}`);
  }

  refill(medUnique, quantity) {
    return this.client.put(`/medication-dispensed/medications/refill/${medUnique}?refillQuantity=${quantity}`)
  }

  setupReminder( payload) {
    return this.client.post('/intake/setup', payload);
  }

  findReminderDetail(medUnique) {
    return this.client.get(`/intake/latest/${medUnique}`);
  }

  deleteReminder(reminderUnique)  {
    return this.client.delete(`/intake/${reminderUnique}`);
  }

  getMedicationContent(medUnique) {
    return this.client.get(`/medication/${medUnique}`);
  }
}

export default new MyMedicationRepository();
